import React from "react";
import { Navigate } from "react-router-dom";
import { getUserId, bootstrapSwitchAuthFromUrl } from "../../utils/cookieUtils";

const ProtectedRoute = ({ isAuthenticated, children }) => {
    // Last-chance bootstrap if App somehow missed URL params
    const { didBootstrap } = bootstrapSwitchAuthFromUrl();
    const cookieUserId = getUserId();

    if (didBootstrap || cookieUserId) {
        return children;
    }

    if (isAuthenticated === null) {
        return <h2>Loading...</h2>;
    }

    return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
